import React, { useState } from "react";
import { useDisclosure } from "@chakra-ui/hooks";
import { Modal, ModalBody, ModalOverlay, ModalHeader } from "@chakra-ui/modal";
import CustomerRegistrationForm from "./CustomerRegistrationForm";
import { MdHighlightOff } from "react-icons/md";
import { getClientsSecond } from "api/graphQL_clients";

const CreateCustomerModal = ({
  fetchClients,
  roleData,
}: {
  fetchClients: () => void;
  roleData?: any;
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isCloseModal, setIsCloseModal] = React.useState<boolean>(false);
  const [clients, setClients] = useState<any[]>([]);
  const [page] = useState<number>(1);
  const [pageSize] = useState<number>(500);

  const handleClose = () => {
    setIsCloseModal(true);
    setTimeout(() => {
      setIsCloseModal(false);
      onClose();
    }, 320);
  };

  const fetchClientsList = () => {
    const params = { page, per_page: pageSize, searchTexts: "" };
    getClientsSecond(params).then((data) => {
      setClients(
        data?.[0]?.map((ele: any) => ({
          name: ele.name,
          id: ele.client_id,
        }))
      );
    });
  };

  return (
    <>
      {/* Trigger button */}
      <button
        className="ccm-add-btn"
        onClick={() => {
          fetchClientsList();
          onOpen();
        }}
      >
        <svg
          width="15"
          height="15"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="8" x2="12" y2="16" />
          <line x1="8" y1="12" x2="16" y2="12" />
        </svg>
        Add New Customer
      </button>

      <Modal isOpen={isOpen} onClose={() => {}}>
        <ModalOverlay bg="rgba(15,23,42,0.55)" backdropFilter="blur(4px)" />

        <div
          className={`ccm-panel${
            isOpen && !isCloseModal ? " ccm-panel--open" : " ccm-panel--close"
          }`}
        >
          {/* Top glow bar */}
          <div className="ccm-top-glow" />

          {/* Header */}
          <div className="ccm-header">
            <div className="ccm-header-brand">
              <div className="ccm-header-logo">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#fff"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                  <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
              </div>
              <div>
                <h2 className="ccm-header-title">Add New Customer</h2>
                <p className="ccm-header-sub">
                  Fill in customer details step by step
                </p>
              </div>
            </div>
            <button
              className="ccm-close-btn"
              onClick={handleClose}
              aria-label="Close"
            >
              <MdHighlightOff size={22} />
            </button>
          </div>

          {/* Body */}
          {/* <div className="ccm-body"> */}
            <CustomerRegistrationForm
              onClose={handleClose}
              clients={clients}
              fetchClients={fetchClients}
            />
          {/* </div> */}
        </div>
      </Modal>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

        /* Add button */
        .ccm-add-btn {
          display: inline-flex; align-items: center; gap: 7px;
          font-family: 'Plus Jakarta Sans', sans-serif;
          font-size: 13.5px; font-weight: 700; color: #fff;
          padding: 10px 20px; border-radius: 10px; border: none;
          background: linear-gradient(135deg, #15803d, #16a34a);
          cursor: pointer; 
          box-shadow: 0 3px 12px rgba(22,163,74,.3);
          transition: transform .15s, box-shadow .18s;
        }
        .ccm-add-btn:hover { transform: translateY(-1px); box-shadow: 0 6px 20px rgba(22,163,74,.38); }

        /* Slide panel */
        .ccm-panel {
          font-family: 'Plus Jakarta Sans', sans-serif;
          position: fixed; top: 0; right: 0; bottom: 0;
          width: 100%; max-width: 900px;
          background: #ffffff;
          z-index: 1004;
          display: flex; flex-direction: column;
          box-shadow: -12px 0 60px rgba(15,23,42,.18);
          transition: transform .35s cubic-bezier(0.16,1,0.3,1);
          overflow: hidden;
        }
        .ccm-panel--open  { transform: translateX(0); }
        .ccm-panel--close { transform: translateX(100%); }

        /* Top glow */
        .ccm-top-glow {
          height: 3px;
          background: linear-gradient(90deg,#0f2744,#16a34a,#2563eb,#16a34a,#0f2744);
          background-size: 200% 100%;
          animation: ccmGlow 3s linear infinite;
          flex-shrink: 0;
        }
        @keyframes ccmGlow { 0%{background-position:0%} 100%{background-position:200%} }

        /* Header */
        .ccm-header {
          padding: 15px 26px;
          background: linear-gradient(135deg, #052e16 0%, #14532d 60%, #16a34a 100%);
          display: flex; align-items: center; justify-content: space-between;
          flex-shrink: 0;
        }
        .ccm-header-brand { display: flex; align-items: center; gap: 13px; }
        .ccm-header-logo {
          width: 42px; height: 42px; border-radius: 12px;
          background: rgba(255,255,255,.15);
          border: 1.5px solid rgba(255,255,255,.25);
          display: flex; align-items: center; justify-content: center;
          flex-shrink: 0;
        }
        .ccm-header-title {
          font-size: 16px; font-weight: 800; color: #fff;
          letter-spacing: -.3px; margin-bottom: 2px; line-height: 1;
        }
        .ccm-header-sub { font-size: 12px; color: rgba(255,255,255,.55); font-weight: 500; }
        .ccm-close-btn {
          background: none; border: none; cursor: pointer;
          color: rgba(255,255,255,.65);
          display: flex; align-items: center; padding: 2px;
          transition: color .15s;
        }
        .ccm-close-btn:hover { color: #fff; }

        /* Body — scrollable */
        .ccm-body {
          flex: 1;
          overflow-y: auto;
          overflow-x: hidden;
        }
        .ccm-body::-webkit-scrollbar { width: 4px; }
        .ccm-body::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }

        @media (max-width: 640px) {
          .ccm-panel { max-width: 100%; }
          .ccm-header { padding: 16px 18px; }
        }
      `}</style>
    </>
  );
};

export default CreateCustomerModal;